import React from "react";

const AboutStorySection = () => {
  return (
    <section className="section about-story-section">
      <div className="container">
        <div className="split-grid">
          <div
            className="section-image about-story-image"
            aria-label="Professional reviewing job-search progress"
          ></div>
          <div>
            <p className="eyebrow">Our Story</p>
            <h2>
              Built from the frustration of applying everywhere and hearing
              nothing.
            </h2>
            <p>
              Lovapex began in 2020 after seeing talented professionals send
              200+ applications and still receive little to no response. The
              issue was not effort. It was the lack of a coordinated system for
              positioning, outreach, follow-up, and tracking.
            </p>
            <p>
              What started as hands-on support for a small group of candidates
              has grown into a platform and service model supporting many
              professionals through structured career management, recruiter
              connection, and application execution.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutStorySection;
